var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F7931A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0527 13.7203C23.3712 11.5911 21.75 10.4465 19.5333 9.68291L20.2524 6.79861L18.4967 6.36106L17.7966 9.16936C17.3351 9.05435 16.861 8.94583 16.39 8.83832L17.095 6.01152L15.3404 5.57397L14.6208 8.45728C14.2387 8.37027 13.8637 8.28426 13.4997 8.19375L13.5017 8.18475L11.0804 7.58019L10.6134 9.45539C10.6134 9.45539 11.916 9.75392 11.8885 9.77242C12.5996 9.94994 12.7281 10.4205 12.7066 10.7935L11.8875 14.0794C11.9365 14.0919 12 14.1099 12.07 14.1379C12.0115 14.1234 11.949 14.1074 11.8845 14.0919L10.7364 18.6949C10.6494 18.9109 10.4288 19.2349 9.93179 19.1119C9.94929 19.1374 8.65565 18.7934 8.65565 18.7934L7.78406 20.8031L10.0688 21.3727C10.4938 21.4792 10.9104 21.5907 11.3204 21.6957L10.5939 24.613L12.3475 25.0506L13.0671 22.1642C13.5462 22.2943 14.0112 22.4143 14.4663 22.5273L13.7492 25.4001L15.5049 25.8376L16.2315 22.9258C19.2253 23.4924 21.4765 23.2639 22.4241 20.5561C23.1877 18.3758 22.3861 17.1182 20.8109 16.2981C21.9581 16.0336 22.8222 15.279 23.0527 13.7203ZM19.0413 19.3454C18.4987 21.5257 14.8278 20.347 13.6377 20.0515L14.6018 16.1866C15.7919 16.4836 19.6083 17.0717 19.0413 19.3454ZM19.5843 13.6888C19.0893 15.6721 16.0339 14.6644 15.0428 14.4174L15.9169 10.912C16.908 11.1591 20.0999 11.6201 19.5843 13.6888Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/BTC.1a603c991c11981c8ed8bf8f3d39fff9.svg";
export { ForwardRef as ReactComponent };